import { createContext, useContext } from 'react';
import type { AvcAuthErrorReason, AvcConnectStep } from '../avc-connect-modal.types';

export interface AvcConnectContextValue {
  isOpen: boolean;
  open: () => void;
  openWithError: (reason: AvcAuthErrorReason) => void;
  close: () => void;
  step: AvcConnectStep;
  errorReason?: AvcAuthErrorReason;
  isRedirecting: boolean;
  startConnect: () => void;
}

export const AvcConnectContext = createContext<AvcConnectContextValue | undefined>(undefined);

export function useAvcConnect(): AvcConnectContextValue {
  const context = useContext(AvcConnectContext);
  if (!context) {
    throw new Error('useAvcConnect must be used within an AvcConnectProvider');
  }
  return context;
}
